import { cn }  from "lib/utils";
import { CheckCircleIcon, ArrowIcon } from "../asset/icons";
import  capitalizeWords from "../utilities/capitalizeWords";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "./ui/Dropdown";
import { useState } from "react";

const FilterButton = ({
    type = "Status",
    label = "All",
    hasCaret = false,
    filterList = [],
    filterTitle = "Filter by",
    onSelect,
    selected
}) => {
    const [open, setOpen] = useState(false)
    // const [tempValue, setTempValue] = useState('')
    const firstLabel = filterList[0] !== 'string' ? filterList[0]?.text : filterList[0];
    return (
        <DropdownMenu open={open} onOpenChange={() => setOpen((p) => !p)}>
            <DropdownMenuTrigger asChild>
                <button
                    className={cn(
                        "text-gray-90 font-[450] text-sm flex items-center gap-x-1 justify-start",
                        hasCaret && "bg-[#F7F8FD] rounded-2xl py-1 px-2"
                    )}
                >
                    <span className="font-light text-gray-70">{type}:</span>{" "}
                    <span className="capitalize">
                        {selected || firstLabel || label}
                    </span>
                    {hasCaret && <ArrowIcon className={`ml-1.5`} />}
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                className=" bg-white z-[200] h-full w-[300px] shadow-none rounded-xl overflow-hidden border border-[#E6E8F9]"
                align="start"
            >
                <p className="px-3 py-2 font-[450] text-gray-90 text-sm md:text-base">
                    {filterTitle}
                </p>
                <div className="flex flex-col items-start mt-1 max-h-[227px] px-3 scroll-smooth overflow-y-auto">
                    {filterList.map((filter, index) => {
                        const isString = typeof filter === "string";
                        const label = isString ? filter : filter.text;
                        const value = isString ? filter : filter.value;

                        return (
                            <div
                                key={value + index}
                                onClick={() => onSelect?.(isString ? label: value)}
                                className="flex items-center justify-between w-full py-2 cursor-pointer gap-x-2"
                            >
                                <p className="text-sm capitalize md:text-base text-[#475467] font-normal">
                                    {label}
                                </p>
                                {label === selected || value === selected ? (
                                    <div className="flex items-center justify-center ml-auto !bg-white p-0 rounded-full shrink-0">
                                        <CheckCircleIcon />
                                    </div>
                                ) : (
                                    <div className="flex ml-auto border rounded-full shrink-0 size-4"></div>
                                )}
                            </div>
                        );
                    })}
                </div>
                <div className="px-3 ">
                    <button
                        onClick={() => {
                            setOpen(false)
                        }}
                        className="my-2 flex items-center justify-center h-[40px] text-center w-full px-3 py-3 text-sm font-normal rounded-md !bg-secondary text-white gap-x-2"
                    >
                        Apply
                    </button>
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default FilterButton